<template>
    <div class="row">
      <div class="col-6">
        <label for="inputDataInicio">Data Inicial</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="dataInicio"><i class="fas fa-calendar-alt fa-fw"></i></span>
          </div>
          <input type="date" :id="`${id}_inputDataInicio`" name="startDate" v-model="startDateLocal" class="form-control" :required="required">
        </div>
      </div>
      <div class="col-6">
        <label for="inputDataFim">Data Final</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="dataFim"><i class="fas fa-calendar-alt fa-fw"></i></span>
          </div>
          <input type="date" :id="`${id}_inputDataFim`" name="endDate" v-model="endDateLocal" class="form-control" :required="required">
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  
  export default {
    props: {
      id: String,
      start: String,
      end: String,
      required: {
        type: Boolean,
        default: true
      },
      autofill: {
        type: String,
        default: 'monthly'
      }
    },
    data() {
      return {
        startDateLocal: this.start || '',
        endDateLocal: this.end || ''
      }
    },
    watch: {
      startDateLocal(newVal) {
        this.$emit('update:start', newVal);
      },
      endDateLocal(newVal) {
        this.$emit('update:end', newVal);
      }
    },
    mounted() {
      // Apenas define valores padrão se pai não passar nenhum
      if (!this.start && !this.end && this.autofill === 'monthly') {
        this.startDateLocal = moment().startOf('month').format('YYYY-MM-DD');
        this.endDateLocal = moment().format('YYYY-MM-DD');
        // Emite os valores padrão
        this.$emit('update:start', this.startDateLocal);
        this.$emit('update:end', this.endDateLocal);
      }
    }
  }
  </script>
  